import { Reducer } from 'redux';

interface ConnectionUpdaterState {
  isConnected: boolean;
}

const initialState: ConnectionUpdaterState = {
  isConnected: false,
};

const connectionStatusReducer: Reducer<ConnectionUpdaterState> = (state = initialState, action) => {
  switch (action.type) {
    case 'CONNECTED':
      return {
        ...state,
        isConnected: true,
      };
    case 'DISCONNECTED':
      return {
        ...state,
        isConnected: false,
      };
    default:
      return state;
  }
};

export default connectionStatusReducer;
